/* eslint-disable import/no-extraneous-dependencies */
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'typeface-muli';
import React from 'react';
import ReactDOM from 'react-dom';
import './react-table-defaults';
import './styles/index.css';
// import './fake-db/fake-db';
import {
  StylesProvider,
  createGenerateClassName,
  jssPreset,
} from '@material-ui/core/styles';
import { create } from 'jss';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import jssExtend from 'jss-extend';
import { FuseLayout, FuseTheme, FuseAuthorization } from './@fuse';
import { unregister } from './registerServiceWorker';
import { routes } from './fuse-configs/fuseRoutesConfig';
import MainToolbar from './main/MainToolbar';
import MainNavbarContent from './main/MainNavbarContent';
import MainNavbarHeader from './main/MainNavbarHeader';
import history from './history';
import store from './store';
import { Auth } from './auth';

unregister();

const jss = create({
  plugins: [...jssPreset().plugins, jssExtend()],
  insertionPoint: document.getElementById('jss-insertion-point') || undefined,
});

const generateClassName = createGenerateClassName({});

ReactDOM.render(
  <StylesProvider jss={jss} generateClassName={generateClassName}>
    <Provider store={store}>
      <Router history={history}>
        <Auth>
          <FuseAuthorization routes={routes}>
            <FuseTheme>
              <FuseLayout
                routes={routes}
                toolbar={<MainToolbar />}
                navbarHeader={<MainNavbarHeader />}
                navbarContent={<MainNavbarContent />}
              />
            </FuseTheme>
          </FuseAuthorization>
        </Auth>
      </Router>
    </Provider>
  </StylesProvider>,
  document.getElementById('root')
);
